// A2-581 screen map lead 4: a run that ends with rows blocking filing
// (unclassified, or waiting on a VAT-number check) raised its message in the
// Step 1-3 panel, but the run then moves to Review and that panel unmounts:
// the operator landed on Review with no message. The message is kept for the
// calculation it belongs to and shown by the review page, once.
// Review of 901b0006: a message never taken (the operator went elsewhere)
// lapses, so it cannot pop up later when that calculation is opened.
export const NOTICE_TTL_MS = 5 * 60 * 1000;
let notice = null;   // { calcId, title, body, at }

export const setCalcOutcomeNotice = (calcId, title, body) => {
  notice = calcId ? { calcId, title, body, at: Date.now() } : null;
};
export const takeCalcOutcomeNotice = (calcId) => {
  if (notice && Date.now() - notice.at > NOTICE_TTL_MS) notice = null;
  if (!notice || !calcId || notice.calcId !== calcId) return null;
  const n = notice;
  notice = null;
  return n;
};
